import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

/**
 * A real 404. The legacy app redirected every unknown path to the dashboard, which
 * made broken links invisible.
 */
export function NotFound() {
  return (
    <div className={styles.container}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.message}>That page does not exist, or you no longer have access to it.</p>
      <Link className={styles.action} to="/">
        Go to dashboard
      </Link>
    </div>
  );
}
